import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GigsApiResponse } from '../../models/gigs.model';

@Injectable({
  providedIn: 'root',
})
export class GigsService {
  constructor(private http: HttpClient) {}
  serviceDetails(service_id: string) {
    return this.http.get(`${environment.endpoint}/services/${service_id}`);
  }
  serviceSearch(search_params: any) {
    return this.http.get(`${environment.endpoint}/search/service${search_params}`);
  }
  projectSearch(search_params: any) {
    return this.http.get(`${environment.endpoint}/search/project${search_params}`);
  }
  clientSearch(search_params: any) {
    return this.http.get(`${environment.endpoint}/search/client${search_params}`);
  }
  freelancerSearch(search_params: any) {
    return this.http.get(`${environment.endpoint}/search/freelancer${search_params}`);
  }
  requestService(data: any) {
    return this.http.post<GigsApiResponse>(`${environment.endpoint}/service-requests`, data);
  }
}
